/*!
 * Copyright (c) 2026 Elevation Technologies Pte Ltd.
 * Developer: filimoni@elevationtech.com.fj
 */
import React from 'react';
import GalleryBlock from './GalleryBlock';
import HtmlBlock from './HtmlBlock';
import TabsBlock from './TabsBlock';
import VideoFrame from './VideoFrame';

export default function BlockRenderer({ block, index }) {
  if (!block) {
    return null;
  }

  if (block.type === 'tabs') {
    return <TabsBlock items={block.items} />;
  }

  if (block.type === 'gallery') {
    return <GalleryBlock images={block.images} />;
  }

  if (block.type === 'video') {
    return (
      <section className="fsf-video-block">
        <VideoFrame url={block.url} title={`Freight Services Fiji video ${index + 1}`} />
      </section>
    );
  }

  return <HtmlBlock html={block.html} />;
}
